 
export const STRING_CONSTANTS = {
  STATUS_CODE_SUCCESS: 201,
  STATUS_CODE_SUCCESS_DATA: 200
};

/** Hardcoded AI assist / help-center service base URL (temporary until env is wired in all environments). */
export const HELP_CENTER_CHATPAGE_SERVICE_BASE_URL =
  'https://csp-backbase-notification.az-demo.bcm.industrycloud.pwc.com';
export const DEFAULT_LIST_SIZE = 10;
export const DEBOUNCE_DELAY = 200;
export const DEFAULT_PAGE_NUMBER = 0;

export const FULFILLED = 'fulfilled';
export const VER = 'Ver';

export const cloneConstant = {
  CLONE_TXT: 'Clone'
};

export const URL_PATH = {
  CONTROL_PLANE: '/control-plane',
  REGISTRIES: '/control-plane/registries',
  SERVICE_HOME: '/control-plane/services',
  AI_SERVICE_HOME: '/control-plane/ai-service',
  EVENT_HOME: '/control-plane/events',
  DASHBOARD: '/control-plane/dashboard',
  CREATE_SERVICE: '/createService',
  SERVICE_DEPENDENCY: '/service-association',
  CREATE_EXCEPTION: '/exceptions',
  CREATE_SERVICE_OPERATION: '/serviceOperations',
  VIEW_SERVICE: '/viewServiceDetails',
  VIEW_EXCEPTION: '/viewExceptions',
  VIEW_SERVICE_OPERATION: '/viewServiceOperation',
  VIEW_EVENT: '/view',
  CREATE_EVENT: '/createEvent',
  UPLOAD_FILE: '/files/upload-files',
  EXCEPTION_HOME: '/exceptions',
  EXCEPTION_CREATE: '/exceptions/create',
  EXCEPTION_VIEW: '/exceptions/view',
  EXCEPTION_EDIT: '/exceptions/edit',
  JOURNEY_PATH: '/journey-designer/journeys/view'
};

export const VIEW_SERVICE_URL_PATH = ['viewServiceDetails', 'viewExceptions', 'viewServiceOperation'];

export const swaggerFileType = {
  JSON: 'json',
  YML: 'yml',
  YAML: 'yaml'
};

export const sagaErrorConst = {
  createAssociationMessage: 'Error while creating new service event assocication',
  createServiceMessage: 'Error while creating new service',
  createEventMessage: 'Error while creating new event',
  patchEventMessage: 'Error while updating status of Event',
  updateAssociationMessage: 'Error while creating new service event assocication',
};

export const dropDownValue = [
  {
    label: 'Notify',
    value: 'Notify'
  },
  {
    label: 'Compensate',
    value: 'Compensate'
  },
  {
    label: 'Ignore',
    value: 'Ignore'
  }
];

export const validErrorCodes = ['400', '401', '402', '403', '404', '405', '406', '407', '408', '409', '410', '411', '412', '413', '414', '415', '416', '417', '418', '421', '422', '423', '424', '425', '426', '428', '429', '431', '451', '500', '501', '502', '503', '504', '505', '506', '507', '508', '510', '511'];

export const eventMandateFields = ['eventName', 'description', 'schemaName'];

export const URL_REGISTRY = {
  SOURCE_REGISTRY: '/control-plane/registries/source-registry',
  PATTERN_REGISTRY: '/control-plane/registries/pattern-registry',
  VIEW_PATTERN_REGISTRY: '/control-plane/registries/pattern-registry/view-pattern',
  SOURCE_EVENT_REGISTRY: '/control-plane/registries/src-event-registry',
  CREATE_SOURCE_REGISTRY: '/control-plane/registries/source-registry/create',
  VIEW_SOURCE_REGISTRY: '/control-plane/registries/source-registry/view',
  CREATE_PATTERN_REGISTRY: '/control-plane/registries/pattern-registry/create-pattern',
  CREATE_SOURCE_EVENT_REGISTRY: '/control-plane/registries/src-event-registry/create-src-event',
  FSM_REGISTRY: '/control-plane/registries/fsm-state-registry',
  CREATE_FSM_REGISTRY: '/control-plane/registries/fsm-state-registry/create-fsm-state',
  VIEW_SOURCE_EVENT_REGISTRY: '/control-plane/registries/src-event-registry/view-source-event',
  EDIT_SOURCE_EVENT_REGISTRY: '/control-plane/registries/src-event-registry/edit-source-event',
  EDIT_SOURCE_REGISTRY: '/control-plane/registries/source-registry/edit',
  EDIT_PATTERN_REGISTRY: '/control-plane/registries/pattern-registry/edit-pattern',
  VIEW_FSM_REGISTRY: '/control-plane/registries/fsm-state-registry/view-fsm-state',
  EDIT_FSM_REGISTRY: '/control-plane/registries/fsm-state-registry/edit-fsm-state',
  SOURCE_TOPIC_REGISTRY: '/control-plane/registries/src-topic-registry',
  CREATE_SOURCE_TOPIC_REGISTRY: '/control-plane/registries/src-topic-registry/create-src-topic',
  VIEW_SOURCE_TOPIC_REGISTRY: '/control-plane/registries/src-topic-registry/view-source-topic',
  EDIT_SOURCE_TOPIC_REGISTRY: '/control-plane/registries/src-topic-registry/edit-source-topic',
};

export const AUTOCOMPLETE_FIELD = {
  eventName: 'event name',
  sourceName: 'source name',
  exceptionName: 'exception name',
  FOOTER_TYPE: 'paging'
};

export const APPPLIED_FILTER = {
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  DATE: 'date',
  STATUS: 'status'
};

export const FILTER_TYPE = {
  STATUS: 'status',
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  DATE: 'date',
};

export const SORT_TYPE = {
  UPDATED_TIMESTAMP: 'updatedTimestamp',
  UPDATED_TIMESTAMP_DESC: 'updatedTimestamp,DESC',
  ASCENDING: 'ASC',
  DESCENDING: 'DESC'
};

export const REGISTRY_MODE = {
  EDIT: 'edit',
  VIEW: 'view'
};
